import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMatches, useNavigation } from 'react-router-dom';

import { SITE_NAME } from '@/config';
import { useScrollToTop } from '@/hooks';
import routes from '@/routes';

export function usePageTitle() {
	const { t, i18n } = useTranslation();
	const matches = useMatches();
	const pageNotFound = useSelector(state => state.site.pageNotFound);

	useEffect(() => {
		let title = '';
		for (const match of matches) {
			if (pageNotFound) {
				title = t('pageTitles.notFound');
				break;
			}
			const localeKey = `pageTitles.${match.id}`;
			const seoLocaleKey = `seo.${match.id}.title`;
			const hasTitle = i18n.exists(localeKey);
			const hasSeoTitle = i18n.exists(seoLocaleKey);

			if (match.id && (hasTitle || hasSeoTitle)) {
				title = t(hasSeoTitle ? seoLocaleKey : localeKey, {
					siteName: SITE_NAME
				});
				break;
			}
		}
		const newTitle = title || SITE_NAME;
		document.title = newTitle;
		document
			.querySelector('meta[property="og:title"]')
			.setAttribute('content', newTitle);
		document
			.querySelector('meta[name="twitter:title"]')
			.setAttribute('content', newTitle);
	}, [matches, i18n.language, pageNotFound, t]);
}

export function useLayout() {
	useScrollToTop();
	usePageTitle();
}

export function useIsLoadingCheckout() {
	const navigation = useNavigation();

	return (
		navigation.state === 'loading' &&
		navigation.location?.pathname === routes.checkout
	);
}
